'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

function ResolveProviderFactory() {
  function ResolveProvider(context) {
    context.resolve = (0, _utils.createResolver)({
      state: context.state.get,
      props: context.props,
      input: context.input,
      signal: context.controller.getSignal.bind(context.controller)
    });

    return context;
  }

  return ResolveProvider;
}

exports.default = ResolveProviderFactory;
//# sourceMappingURL=Resolve.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/lib/providers/Resolve.js
// module id = 718
// module chunks = 0